import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log error to state
    this.setState({ error, errorInfo })
    // Send error to backend for logging
    this.logErrorToService(error, errorInfo)
  }

  logErrorToService = async (error, errorInfo) => {
    const errorDetails = {
      error: error.toString(),
      stack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    }
    console.log({ errorDetails })
    try {
      await fetch('http://127.0.0.1:5000/api/v1/investor/pending-investments-trigger', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(errorDetails),
      })
    } catch (err) {
      console.error('Failed to send error log to server:')
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please try again later.</h1>
    }
    return this.props.children
  }
}

export default ErrorBoundary
